import React, { useState } from 'react';
import { useAuth } from '../state/auth';
import { useToast } from '../components/Toast';
import { getLocation } from '../hooks/useGeolocation';
import login_bg from '../../public/bg/login_bg.png';
export function LoginPage() {
  const { login } = useAuth();
  const { push } = useToast();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(true);
  const [loading, setLoading] = useState(false);
  const [useLoc, setUseLoc] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      const location = useLoc ? await getLocation().catch(() => undefined) : undefined;
      await login(username.trim(), password, remember, location);
      push({ title: 'Accesso effettuato' });
    } catch (err: any) {
      push({ title: 'Login non riuscito', body: err?.data?.error || err?.message });
    } finally {
      setLoading(false);
    }
  }

 return (
  <div
    className="min-h-screen grid place-items-center px-4 py-10 sm:px-6"
    style={{
      backgroundImage: `url(${login_bg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    }}
  >
    {/* wrapper width: full su mobile, max su desktop */}
    <div className="w-full max-w-[980px]">
      <div className="card_login bg-black/85 rounded-2xl p-5 sm:p-8 md:p-10">
        {/* header */}
        <div className="flex flex-col items-center text-center">
          <img
            className="h-15 sm:h-15 md:h-30"
            src="/brand/infinityWifi.png"
            alt="INFINITY WIFI"
          />

          <div className="mt-6 font-bold text-2xl sm:text-3xl md:text-4xl">
            Registro presenze
          </div>
          <div className="mt-2 text-base sm:text-lg md:text-xl text-white/90">
            Accesso sicuro per dipendenti e titolare.
          </div>
        </div>

        {/* bullets */}
        <div className="flex flex-col justify-center text-center pt-6 gap-2 text-sm sm:text-base">
          <div>• Dipendente: ottimizzato per <b>smartphone</b></div>
          <div>• Titolare: gestionale ottimizzato per <b>desktop</b></div>
        </div>

        {/* form */}
        <form
          onSubmit={onSubmit}
          className="mt-8 flex flex-col gap-3 sm:gap-4 w-full max-w-md mx-auto"
        >
          <input
            className="input w-full"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
          />
          <input
            className="input w-full"
            placeholder="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />

          {/* checkbox row: colonna su mobile, riga da sm in su */}
          <div className="pt-4 pb-6 flex flex-col gap-3 sm:flex-row sm:justify-between sm:items-center text-sm">
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
              />
              Ricordami
            </label>

            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={useLoc}
                onChange={(e) => setUseLoc(e.target.checked)}
              />
              Posizione al login
            </label>
          </div>

          <button
            className="btn btnPrimary bg-red-700 w-full"
            disabled={loading || !username || !password}
          >
            {loading ? <span className="spinner" aria-hidden="true" /> : null}
            <span>{loading ? "Accesso in corso…" : "Entra"}</span>
          </button>
        </form>

        <div className="mt-6 text-center poweredBy text-xs sm:text-sm text-white/80">
          Powered by <b>Mattia Donizetti</b>
        </div>
      </div>
    </div>
  </div>
);

}
